import type {
  ConfirmarSimulacaoDialogProps,
  ConfirmarSimulacaoDialogViewModel,
} from "./types-confirmar-simulacao-dialog";

export function useConfirmarSimulacaoDialog({
  titulo,
  mensagem,
  confirmarLabel,
  cancelarLabel = "Cancelar",
  onConfirmar,
  onCancelar,
  testId,
}: ConfirmarSimulacaoDialogProps): ConfirmarSimulacaoDialogViewModel {
  return {
    titulo,
    mensagem,
    confirmarLabel,
    cancelarLabel,
    testId,
    cancelarTestId: `${testId}-cancelar`,
    confirmarTestId: `${testId}-confirmar`,
    onConfirmar,
    onCancelar,
  };
}
